import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";
import PathInfo from "../../model/PathInfo";
import APIEndPoints from "../../utils/APIEndPoints";
import PathDisplay from "../common/PathDisplay";
import _3DInstance from "../../model/_3DInstance";

function _3dInstances() {
  // read the ID from the url
  const { e3dinstid, id } = useParams();
  const auxId = id ? id : e3dinstid;
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (auxId) {
        const info = await apiClient?.get<_3DInstance>({
          url: APIEndPoints._3DINSTANCES.ONE(parseInt(auxId)),
        });

        setPathInfo(
          new PathInfo(
            info.id!,
            info.name,
            ChemiNovaEntityType._3DINSTANCE,
            info.parent,
            e3dinstid ? false : true
          )
        );
      }
    };
    getPathInfo();
  }, [location]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default _3dInstances;
